export default "__VITE_ASSET__9X2TqXv4__"